<!--Banner part code-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel  uk-flex-center uk-flex-middle"
            style="background-image: url(../../assets/e-commercebanner.png);">
            <div class="uk-section uk-light">
                <div class= "uk-container-small uk-width-2xlarge" style="padding-top:20px ;">

                    <h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">E-Commerce Web Development</h1>


                   
                    <p class="uk-text-left uk-padding-large uk-padding-remove-vertical" style="font-size: 20px;">
                        WebSoulLabs have a team of web designers in fuelled by creativity who develop most beautiful websites that create a lasting impression on the viewers.

                        
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Banner part code ends-->

<div class="uk-section uk-padding" style=" padding-bottom: 0px;">
    <div class="uk-container">
      
          <h2 class="uk-text-center" style="font-weight:600">Creating a strategy that’s right for your business </h2>
          <br>
          <div class="uk-column-1-2@s">
  
              
              <p class="uk-text-medium uk-text-justify" style="font: size 18px;">We develop and design scalable websites with
                 personalized and user-friendly features. These websites can give you a wide exposure for your business.
                  By aligning to your business objectives, we aspire to deliver a solution that is dynamic, functional
                   and tailored to your needs.</p>
                  <p class="uk-text-medium uk-text-justify"style="font: size 18px;">Bring to us your most 
                    intricate business challenges, and we will turn them into real digital commerce 
                    breakthroughs. Our team of developers can effortlessly execute the most complex 
                    integrations and help you develop high earning, customer-centric E-Commerce solutions.</p>
              <img data-src="assets/cross.jpg" style="width:600px; height:300px" alt="" uk-img>
  
          </div>
    </div>
</div>


<!--Services part code-->
<div class="uk-container uk-container-expand">
    <div class="ws-services  uk-child-width-1-3@s uk-flex-center uk-light uk-grid-match" uk-grid>
        <h1 class="uk-padding-small  uk-align-center" style="font-weight:600; margin-bottom: 0px;">Get your business online and delight the goals </h1>
        <div>
            <div class="uk-placeholder uk-text-center uk-panel">
                 <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                
                     

                    <!-- <img class="uk-border-circle uk-align-center" src="assets/white.jpg"  width="68" height="68"
                        
                    alt="border-circle"> -->
                    <div class="pa">
                        <span class="text-white">
                    <img class="uk-border-circle " src="assets/web-development.svg"
                        width="75" height="75" alt="" ></span>
                    </div>
             
                 </div>
                <h3  style="margin-top: 0px;"><strong>Responsive Shopping
                    Website</strong></h3>
                <p class="uk-text-justify"> On these days, E-commerce website design is an important necessity for online marketing
                     because E-commerce websites are the prevailing and upcoming for any kind of business.
                      Your commodities will attain huge amounts of addicts around the globe, by accessing
                       your website on the Internet generating your achievement boost.</p>

            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel ">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">

                    <!-- <img class="uk-border-circle uk-align-center" src="assets/black.png" width="68" height="68"
                        alt="border-circle"> -->
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/consumer.svg"
                        width="70" height="70" alt=""></span>
                </div>
                </div>
                <h3 style="margin-top: 0px;"><strong>Customized Web
                    Development</strong></h3>
                <p class="uk-text-justify" > We strive to create customized responsive web development outcomes, not cookie-cutter 
                    missions. Every website we create is completely distinct. Our custom web models do not
                     depend on templates, plugins or categorize strategies. This enables us to deliver you
                      with a customized, user-friendly, durable and credible website.
                </p>

            </div>
        </div>

        <div>
            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <!-- <img class="uk-border-circle uk-align-center" src="assets/black.png" width="68" height="68"
                        alt="border-circle"> -->
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/gear.svg"
                        width="68" height="68" alt=""></span>
                </div>
               </div>
                <h3 style="margin-top: 0px;"><strong>Multiple Payment<br>
                    Gateways</strong></h3>
                <p class="uk-text-justify" >With multiple payment gateways, you can provide your clients with an additional
                     secure online transaction, since the payment gateway can review as well as validate
                      all transactions which belong on your site. The gateway not only ensures your
                       clients – but it also maintains you as a merchant, extremely from the threat 
                       of dishonest transactions.
                </p>

            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel">

                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <!-- <img class="uk-border-circle uk-align-center" src="assets/black.png" width="68" height="68"
                        alt="border-circle"> -->
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/globe.svg"
                        width="70" height="70" alt="border-circle"></span>
                </div>
                </div>
                <h3 style="margin-top: 0px;"><strong>Ecommerce Web
                    Development</strong></h3>
                <p class="uk-text-justify" > E-commerce web development squad assures your website is created with a powerful business
                     technique and the latest growth technologies. Our E-commerce website development outcomes
                      are creative, scalable, deliver quicker time-to-market. </p>

            </div>
        </div>


        <div>

            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <!-- <img class=" uk-border-circle uk-align-center" src="assets/black.png" width="68" height="68"
                        alt="border-circle"> -->
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/qr-code.svg"
                        width="75" height="75" alt=""></span>
                </div>
                </div>
                <h3 style="margin-top: 0px;"><strong>Shopping Cart<br>
                    Development</strong></h3>
                <p class="uk-text-justify" > Online Shopping Cart Development strategy enables you to generate a wider
                     significance to your developments and services. It’s an electronic platform to
                      achieve millions of possible clients through the essential storefront.
                </p>

            </div>
        </div>
        <div>

            <div class="uk-placeholder uk-text-center uk-panel  uk-animation-fast uk-animation-fade">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                 <!-- <div class="uk-border-circle" style="background-color: white;" width="50" height="50" alt="Border circle"> -->
                    <!-- <img class=" uk-border-circle uk-align-center" src="assets/white.jpg" width="68" height="68"
                        alt="border-circle"> -->
                    <div class="pa">
                            <span class="text-white">
                      <img class="uk-border-circle "  src="assets/technical-support.svg"
                        width="68" height="68" alt=""></span>
                   </div>
                 </div>
                
            
                <h3 style="margin-top: 0px;"><strong>Support and<br>
                    Maintenance</strong></h3>
                <p class="uk-text-justify">Website maintenance is very significant for the growth of the business. It contains
                     maintenance of occurring or a functioning website to be protected, ensures data loss
                      prevention without any data being mislaid during the matter of duration.
                </p>

            </div>
        </div>
    </div>
</div>
<!--Services part code ends-->



<!--Related Services part code-->
<h1 class="uk-text-center"><span>Related Services</span></h1>
<br>
<div class="uk-container">
    <div class="uk-grid-small uk-child-width-1-2@s  uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;" >
            
                <img class=" uk-align-center" src="../../assets/icons/cbg11.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">Custom Business<br> Application</h4>
        
            </div>
        </div>
    

        <div>
    
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class="uk-align-center" src="../../assets/icons/phpg5.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">Php Application<br> Development</h4>

        
            </div>
        </div>


        <div>
    
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="../../assets/icons/laravelg6.png" width="100" height="100"
                    alt="">
                <h4 class="uk-text-center" style="font-weight: 600; ">Laravel Application<br>Development</h4>
            </div>
        
        </div>
    

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium "style="padding-top: 30px;" >
                <img class="uk-align-center" src="../../assets/icons/cakeg8.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">CakePhp Application Development</h4>

        
            </div>
        </div>

        <div>
    
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="../../assets/icons/pythong4.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight: 600;">Python <br>Programming </h4>

        
            </div>
        </div>

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class="uk-align-center" src="assets/icons/webdeg.png" width="100" height="100" alt="">
                <h4 class="uk-text-center"  style="font-weight: 600; ">Web Application <br>Development</h4>
            </div>
        </div>

    
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="../../assets/icons/webdesigng12.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style= "font-weight: 600;">Web Design <br>And Development</h4>

            </div>
        </div>
    
    </div>

</div>
<!--Related Services part code ends-->



<!--Technology stack part code-->
<h1 class="uk-text-center"><span>Technology Stack</span></h1>
<br>
<div class="uk-container">
    <div class=" wss uk-child-width-1-4@s uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/thsss.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">WordPress</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/angular.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Angular js</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/post.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Postgres SQL</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/html.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Html</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/css-3.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">CSS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Redis.png" style="width:130px; height:100px"
                    alt="border-circle">
                <h4 style="font-weight:600; margin-top: 30px;">Redis</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/js-logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">JavaScript</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/jest.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4 style="font-weight:600; margin-top:30px;">Jest</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/logo.png" style="width:100px; height:100px;"
                    alt="border-circle">
                <h4 style="font-weight:600; margin-top: 20px;">Redux</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Ruby_logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Ruby On Rails</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/aws.png" width="130" height="130"
                    alt="border-circle">
                <h4 style="font-weight:600">AWS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/ng.jpg" width="80" height="80"
                    alt="border-circle">
                <h4 style="font-weight:600">Nginx</h4>
            </div>
        </div>
    </div>
</div>
<br>
<!--Technology stack part code ends-->